import { normalizePromoCompraSurveyFields } from './promoCompraSurveyFields';

export const PROMO_TIPO_OPTIONS = [
  "Bolsa",
  "Roupa",
  "Cinto",
  "Carteira",
  "Sapato",
  "Relógio",
  "Óculos",
  "Joia",
  "Mochila",
  "Lenço",
];

export const PROMO_TIPOS_LABEL = "Quais tipos você quer ver?";
export const PROMO_BUDGET_LABEL = "Quer investir até quanto hoje?";
export const PROMO_TIPOS_NAME = "promo_quero_ver";
export const PROMO_BUDGET_NAME = "promo_budget";

export const PROMO_BUDGET_OPTIONS = [
  "Até 1k",
  "Até 3k",
  "Até 5k",
  "Até 10k",
  "Até 15k",
  "Até 20k",
  "Até 30k",
  "Até 40k",
  "Até 50k",
  "Até 70k",
  "Até 90k",
  "Até 100k",
];
export const PROMO_OUTRO_NAME = "promo_quero_ver_outro";
export const PROMO_OUTRO_LABEL = "Quer especificar? (opcional)";
export const PROMO_OUTRO_PLACEHOLDER = "Ex: bolsa Chanel preta, cinto fino...";

export const PROMO_OUTRO_FIELD = {
  name: PROMO_OUTRO_NAME,
  label: PROMO_OUTRO_LABEL,
  type: "text",
  required: false,
};

const COMPRA_FIELD_NAMES = new Set(["promo_melhor_dia_mes", "promo_forma_pagamento"]);

function isTiposField(field) {
  if (!field) return false;
  if (field.name === PROMO_TIPOS_NAME) return true;
  const label = String(field.label || "").toLowerCase();
  return label.includes("tipos") && label.includes("ver");
}

function isBudgetField(field) {
  if (!field) return false;
  if (field.name === PROMO_BUDGET_NAME) return true;
  const label = String(field.label || "").toLowerCase();
  return label.includes("investir") || label.includes("pagar");
}

export function withOptionalWrite(fields) {
  const rows = Array.isArray(fields) ? [...fields] : [];
  if (rows.some((f) => f.name === PROMO_OUTRO_NAME)) return rows;
  const tiposIdx = rows.findIndex((f) => isTiposField(f));
  if (tiposIdx >= 0) {
    rows.splice(tiposIdx + 1, 0, PROMO_OUTRO_FIELD);
    return rows;
  }
  rows.push(PROMO_OUTRO_FIELD);
  return rows;
}

/** Garante chips de tipo + teto mesmo se a API devolver campo texto legado. */
export function normalizePromoSurveyFields(fields) {
  const names = new Set((fields || []).map((f) => f.name));
  // Passo 2 (dia/pagamento) — nunca injetar tipos/outro aqui
  if ([...names].some((n) => COMPRA_FIELD_NAMES.has(n))) {
    return normalizePromoCompraSurveyFields();
  }

  const rows = withOptionalWrite(fields).map((f) => ({ ...f }));

  let tipos = rows.find(isTiposField);
  if (!tipos) {
    tipos = {
      name: PROMO_TIPOS_NAME,
      label: PROMO_TIPOS_LABEL,
      type: "checkbox",
      options: [...PROMO_TIPO_OPTIONS],
      required: true,
    };
    rows.unshift(tipos);
  } else {
    tipos.name = PROMO_TIPOS_NAME;
    tipos.type = "checkbox";
    tipos.label = PROMO_TIPOS_LABEL;
    tipos.options = [...PROMO_TIPO_OPTIONS];
    tipos.required = true;
  }

  let budget = rows.find(isBudgetField);
  if (budget) {
    budget.name = PROMO_BUDGET_NAME;
    budget.type = "radio";
    budget.label = PROMO_BUDGET_LABEL;
    budget.options = [...PROMO_BUDGET_OPTIONS];
    budget.required = true;
  }

  return rows;
}

export function isMultiSelect(field) {
  return field?.type === "checkbox" || isTiposField(field);
}

export function displayFieldLabel(field) {
  if (isBudgetField(field)) return PROMO_BUDGET_LABEL;
  if (isTiposField(field)) return PROMO_TIPOS_LABEL;
  if (field?.name === PROMO_OUTRO_NAME) return PROMO_OUTRO_LABEL;
  return field?.label || "";
}

export function fieldOptions(field) {
  if (isMultiSelect(field) && (!field.options || !field.options.length)) {
    return PROMO_TIPO_OPTIONS;
  }
  return field?.options || [];
}

export function emptyAnswer(field) {
  return isMultiSelect(field) ? [] : "";
}

export function isEmptyAnswer(field, value) {
  if (isMultiSelect(field)) {
    return !Array.isArray(value) || value.length === 0;
  }
  return !value;
}

export function isSurveyComplete(fields, answers) {
  if (!Array.isArray(fields)) return false;
  return fields.every(
    (field) => !field.required || !isEmptyAnswer(field, answers[field.name]),
  );
}

export function toggleOption(list, opt) {
  const current = Array.isArray(list) ? list : [];
  return current.includes(opt)
    ? current.filter((v) => v !== opt)
    : [...current, opt];
}
